import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icons/input-arrow.svg'


const _hoisted_1 = { class: "column product list-complete-item" }
const _hoisted_2 = { class: "information" }
const _hoisted_3 = { class: "key" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-input-left" }
const _hoisted_6 = { class: "modal-input-left" }
const _hoisted_7 = { class: "modal-input" }
const _hoisted_8 = { class: "modal-input-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quantity_increaser = _resolveComponent("quantity-increaser")!
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_sheet_modal = _resolveComponent("sheet-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.orderLine.product.name), 1),
      _createElementVNode("p", {
        class: _normalizeClass(["value price", {'order-not-yet-finished': !_ctx.isFinished}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPriceSheetModal()))
      }, _toDisplayString(_ctx.priceFormatting(_ctx.totalProductPrice * _ctx.orderLine.quantity)), 3)
    ]),
    _createVNode(_component_quantity_increaser, {
      "is-finished": _ctx.isFinished,
      product: _ctx.orderLine,
      "product-index": _ctx.index
    }, null, 8, ["is-finished", "product", "product-index"]),
    (_openBlock(), _createBlock(_component_sheet_modal, {
      ref: "productModal",
      key: _ctx.orderLine.product.id,
      title: `Prijs aanpassen - ${_ctx.orderLine.product.name}`
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "modal-input",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setNewPrice(_ctx.orderLine, _ctx.orderLine.product.cost_standard)))
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.priceFormatting(_ctx.orderLine.product.cost_standard)), 1),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-input-right" }, [
              _createTextVNode(" Originele prijs "),
              _createElementVNode("img", {
                alt: "Arrow",
                src: _imports_0
              })
            ], -1))
          ]),
          _createElementVNode("div", {
            class: "modal-input",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setNewPrice(_ctx.orderLine,0)))
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.priceFormatting(0)), 1),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-input-right" }, [
              _createElementVNode("img", {
                alt: "Arrow",
                src: _imports_0
              })
            ], -1))
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "separator" }, "Of", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[7] || (_cache[7] = _createTextVNode(" € ", -1)),
              _createVNode(_component_currency_input, {
                modelValue: _ctx.newPrice,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPrice) = $event)),
                options: {
                                                            currency: 'EUR',
                                                            currencyDisplay: 'hidden',
                                                            hideGroupingSeparatorOnFocus: false,
                                                            hideNegligibleDecimalDigitsOnFocus: false,
                                                            autoDecimalDigits: false,
                                                            useGrouping: true},
                placeholder: 50.00
              }, null, 8, ["modelValue"])
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "modal-input-right" }, [
              _createElementVNode("img", {
                alt: "Arrow",
                src: _imports_0
              })
            ], -1))
          ]),
          _createVNode(_component_ion_button, {
            disabled: !_ctx.newPrice,
            class: "btn primary",
            color: "primary",
            expand: "block",
            shape: "round",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setNewPrice(_ctx.orderLine, _ctx.newPrice)))
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode(" Unieke prijs toevoegen ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["title"]))
  ]))
}